/*
 * @Description: user Mutations
 */
import { MutationTree } from 'vuex'
import { UserState } from './state'
import {UserInfo} from "./state"
import { UserMutationTypes } from './mutation-types'

export type Mutations<S = UserState> = {
  [UserMutationTypes.SET_TOKEN](state: S, token: string): void
  [UserMutationTypes.SET_USER_INFO](state: S, userInfo: UserInfo): void
}

export const mutations: MutationTree<UserState> & Mutations = {
  [UserMutationTypes.SET_TOKEN](state: UserState, token: string) {
    state.token = token
  },
  [UserMutationTypes.SET_USER_INFO](state: UserState, userInfo: UserInfo) {
    state.userInfo = userInfo
  },
}
